import { getHostName, handleDateTimeCardFeed, noNeedToCraw } from '@/util/ds-util';
import axios from 'axios';
import vueCustomScrollbar from 'vue-custom-scrollbar';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
@Component({
  name: 'detail-reference',
  components: {
    vueCustomScrollbar: vueCustomScrollbar,
  },
})
export default class detailReference extends Vue {
  @Prop(Boolean) readonly showDetail: any | undefined;
  @Prop(Array) readonly lstReference: any[];
  @Prop() readonly selectedDoc: any;

  youtubeDomain = ['www.youtube.com', 'm.youtube.com'];
  loading = false;
  interval: any;
  isCheckLoading = false;
  scrollSettings = {
    wheelPropagation: false,
    suppressScrollX: false,
    wheelSpeed: 0.5,
  };
  isShowHtmlContent = true;
  selectDocTmp = '';

  @Watch('selectedDoc')
  showDataWhenChangeDoc() {
    this.selectDocTmp = this.selectedDoc?.docId;
    document.getElementById('detail-reference-doc').scrollIntoView();
  }

  @Watch('showDetail')
  scrollToTopDetailDoc() {
    if (this.showDetail) document.getElementById('detail-reference-doc').scrollIntoView();
  }

  getEmbedLink(url) {
    const id = url?.split('?v=')[1]?.split('&')[0];
    return 'https://www.youtube.com/embed/' + id;
  }

  isYoutube(url) {
    return this.youtubeDomain.some(domain => url.split('/').includes(domain));
  }

  onIframeLoaded() {
    if (this.selectedDoc?.url?.toLowerCase().includes('pdf') || this.selectedDoc?.url?.toLowerCase().includes('ppt')) {
      this.isCheckLoading = true;
    }
    clearInterval(this.interval);
  }

  buildUrl(path): string {
    if (path?.indexOf('/deepsignal/download') > 0) {
      const loc = window.location;
      const baseHref = document.querySelector('base').getAttribute('href');
      const url = loc.origin + baseHref + path.substring(path.indexOf('download'));

      return encodeURIComponent(url);
    } else {
      return encodeURIComponent(path);
    }
  }

  noNeedToCraw(selectedDoc) {
    if (noNeedToCraw(selectedDoc)) {
      this.isShowHtmlContent = false;
    }
    return noNeedToCraw(selectedDoc);
  }

  processDatetime(datetime) {
    return handleDateTimeCardFeed(datetime, this);
  }

  ExtractHostname(url, writer) {
    const name = getHostName(url);
    if (name) return name;
    return writer;
  }

  isDocumentFile(url: any) {
    if (url?.toLowerCase()?.endsWith('.pdf') || url?.toLowerCase()?.endsWith('.ppt')) {
      return true;
    } else {
      return false;
    }
  }
  closeDetail() {
    this.$emit('closeDetail');
  }
  selectOtherDoc(e) {
    this.$emit('selectOtherDoc', e.target.value);
  }

  isShowOriginLink(item) {
    if (item.search_type == 'USERNOTE') {
      return false;
    }
    if (item.docId?.includes('private')) {
      return false;
    }
    if (item.source_uri?.includes('opt/deepsignal/download')) {
      return false;
    }
    return true;
  }

  viewPost(link) {
    const connectome = localStorage.getItem('localStorageUser')
      ? JSON.parse(localStorage.getItem('localStorageUser'))
      : JSON.parse(sessionStorage.getItem('localStorageUser'));
    const userId = connectome?.id;

    const externalUrl = {
      url: this.$route.path,
      originalUrl: this.selectedDoc.url ? this.selectedDoc.url : '',
      title: this.selectedDoc.title ? this.selectedDoc.title : '',
    };

    if (userId) {
      axios.post('/api/external-url/' + userId, externalUrl).then(res => {
        if (res.data && res.data?.shortUrl) {
          window.open('deepsignal/' + res.data.shortUrl, '_blank');
        }
      });
    }
  }
}
